import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import RouteHome from "./RouteHome";
import RouteBook from "./RouteBook";
import { JoinContainer } from "../../join/components";
import { UpdateUserContainer } from "../../member/updateUserInfo/components";
import { UserManagementContainer } from "../../admin/userManagement/components";
import { FindPasswordContainer } from "../../findPassword/components";
import { BookMultiRequestContainer } from "../../book/bookMultiRequest/components";
import { CartContainer } from "../../book/cart/components";
import NotFound from "../../common/components/NotFound";

export default (
  <Routes>
    <Route path="/" element={<RouteHome />} />
    <Route path="/join" element={<JoinContainer />} />
    <Route path="/findPassword" element={<FindPasswordContainer />} />
    {/* 단권 신청 레거시 경로 — 다중권 화면이 동일 기능을 커버해 redirect */}
    <Route path="/bookRequest" element={<Navigate to="/bookMultiRequest" replace />} />
    <Route path="/bookMultiRequest" element={<BookMultiRequestContainer />} />
    <Route path="/cart" element={<CartContainer />} />
    <Route path="/book/:ordNum" element={<RouteBook />} />
    <Route path="/updateUserInfo" element={<UpdateUserContainer />} />
    <Route path="/admin/users" element={<UserManagementContainer />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);
